/* eslint-disable react/button-has-type */
/* eslint-disable arrow-body-style */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../../../images/icons/newsletter'
import styles from './newsletter-button.module.scss';

const NewsletterButton = ({ text = 'Exclusive Offers', toggleNewsLetter, active = true }) => {
  return (
    <button
      onClick={toggleNewsLetter}
      className={`${styles?.button || ''} ${active ? styles.active || '' : ''}`}
    >
      <Icon />
      <span>{text}</span>
    </button>
  );
};

export default NewsletterButton;
